/**
 * Nomes técnicos dos campos CONFIGURÁVEIS da tela do contas a receber (db_financas.campo, id_tela 2),
 * como vêm em `nomeTecnico` de ConfiguracaoCampoObrigatorio/idTela/2. Os fixos (cliente, competência,
 * valor, descrição, vencimento, categoria) o pedido sempre preenche.
 */
export enum CampoContasReceberEnum {
    CentroCusto = 'id_centro_custo',
    Vendedor = 'id_vendedor',
    Nsu = 'nsu_tid',
    Observacoes = 'observacoes_html',
    FormaRecebimento = 'id_forma_recebimento',
    ContaFinanceira = 'id_conta_financeira',
}
